import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchUserByKeyword(_, keyword) {
  try {
    if (keyword !== "") {
      const res = await apiAxios.get(`/users?filter[name][like]=${keyword}`);
      return res.data.data;
    } else {
      const res = await apiAxios.get(`/users`);
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

function useSearchUser(keyword) {
  const { user: userState } = useContext(LoginStateContext);

  return useQuery(["searched-user", keyword], fetchUserByKeyword, {
    enabled: userState.isLoggedIn,
  });
}

export default useSearchUser;
